import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
export type ContentDetails_Tag_ContentReferenceFragmentFragment = {
  __typename?: 'ContentReference'
  id?: string | null
  sortKey?: number | null
  contentReferenceType?: { __typename?: 'ContentReferenceType'; type?: string | null } | null
  contentTo?: Array<{
    __typename?: 'Content'
    id?: string | null
    titleGroupId?: string | null
    title?: string | null
    contentId?: number | null
    contentType?: string | null
    published?: boolean | null
  } | null> | null
}

export const ContentDetails_Tag_ContentReferenceFragmentFragmentDoc = gql`
  fragment ContentDetails_Tag_ContentReferenceFragment on ContentReference {
    id
    sortKey
    contentReferenceType {
      type
    }
    contentTo(language: ["en", "_primary"]) {
      id
      titleGroupId
      title
      contentId
      contentType
      published
    }
  }
`
